export const en = {
    company_name_header: 'Company',
    tp_header: 'Travel policy',
    company_name_placeholder: 'Company name',
    choose_tp_placeholder: 'Choose a travel policy',
    tp_add_success: 'The travel policy has been successfully updated',
    tp_add_error: 'The travel policy could not be updated',
};
